// Helpers puros da lupa da lista de conversas.

const RADIUS = 60;

// Recorta o texto em volta da primeira ocorrência da busca ("…trecho…"), para
// o cartão mostrar o contexto da palavra e não só o começo da mensagem.
export const snippetAround = (text, query, radius = RADIUS) => {
  const source = String(text || '')
    .replace(/\s+/g, ' ')
    .trim();
  const needle = String(query || '')
    .trim()
    .toLowerCase();
  if (!source) return '';
  if (!needle) return source.slice(0, radius * 2);

  const index = source.toLowerCase().indexOf(needle);
  if (index === -1) return source.slice(0, radius * 2);

  const start = Math.max(0, index - radius);
  const end = Math.min(source.length, index + needle.length + radius);
  const prefix = start > 0 ? '…' : '';
  const suffix = end < source.length ? '…' : '';
  return `${prefix}${source.slice(start, end)}${suffix}`;
};

export const MIN_QUERY_LENGTH = 3;
export const PER_PAGE = 15;

export const isSearchable = query =>
  String(query || '').trim().length >= MIN_QUERY_LENGTH;
